module.exports = __webpack_public_path__ + "fe64679a2aff8328d1c0d5ed5ec23fa6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_linkedin_colour.svg
// module id = WS6J
// module chunks = 5